import React, { Component } from 'react'

class TextDivider extends Component {
    render() {
        return (
            <div style={{ display: 'flex', flexDirection: 'row', flexGrow: 1, justifyContent: 'center', alignItems: 'center', ...this.props.containerStyle }}>
                <hr style={{ flex: 1, ...this.props.lineStyle}} />
                <span style={{ paddingLeft: 10, paddingRight: 10, ...this.props.style}}>
                    {this.props.children}
                </span>
                <hr style={{ flex: 1, ...this.props.lineStyle }} />
            </div>
        )
    }
}

export default TextDivider